export const searchKeys = {
  providers: "/public/search",
};
export const historyStorageName = "searchInputValue";
